<template>
  <div class="parking-page" v-infinite-scroll="inScorll" :infinite-scroll-delay="1500" :infinite-scroll-immediate="false">
    <!-- Header -->
    <header class="header">
      <div class="back-button" @click="goBack">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <div class="title">车位优选</div>
      <div class="more-button">
        <el-icon><MoreFilled /></el-icon>
      </div>
    </header>
<!--    <div class="website">www.deepark.com.cn</div>-->

    <!-- Search bar (removed view toggle for now) -->
    <div class="search-row">
      <div class="city-selector" @click="goToCitySelector">
        {{ selectedCity || '南京市' }} <el-icon><ArrowDown /></el-icon>
      </div>

      <div class="search-container">
        <el-icon class="search-icon"><Search /></el-icon>
        <input type="text" class="search-input" placeholder="搜索目的地 | 车场 | 商圈" v-model="searchText">
        <div class="search-button" @click="parkingSearch">搜索</div>
      </div>

      <div class="view-toggle">
        <div :class="{ 'hidden': isMapView }" @click="setMapView(false)">
          <img src="../assets/icons/list.png" height="26" width="26"/>
          <br/>
          <div class="icon-label">列表</div>
        </div>
        <div :class="{ 'hidden': !isMapView }" @click="setMapView(true)">
          <img src="../assets/icons/map.png" height="23" width="23"/>
          <br/>
          <div class="icon-label">地图</div>
        </div>
      </div>
    </div>

    <!-- Category tabs -->
    <div class="category-tabs">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['tab', selectedTab === tab.value ? 'active' : '']"
        @click="selectTab(tab.value)">
        {{ tab.label }}
      </div>
    </div>

    <!-- Ad banner -->
    <div class="ad-banner">
      <div class="follow-tag">关注</div>
      <div class="ad-content">【车位优选】小红书官方号，领福利~</div>
      <el-icon><ArrowRight /></el-icon>
    </div>

    <!-- Map -->
    <div class="map-container" id="mapContainer" v-show="!isMapView"></div>

    <!-- Package spots list -->
    <div class="parking-list" style="margin-bottom: 60px">
      <div v-if="loading" class="loading-state">
<!--        <el-loading />-->
        加载中...
      </div>

      <div v-else-if="packageSpots.length === 0" class="empty-state">
        暂无符合条件的车位套餐
      </div>

      <!-- Package spot items -->
      <div class="parking-item" v-for="(item, index) in packageSpots" :key="index" @click="selectPackage(item)">
<!--        <div class="image-container"  v-if="item.isSharedSpot">-->
<!--        &lt;!&ndash; 图片 &ndash;&gt;-->
<!--        <img :src="getImgUrl(item.parkingImagesList)" alt="Parking"  class="content-img"/>-->

<!--        &lt;!&ndash; 底部蒙版 &ndash;&gt;-->
<!--        <div class="bottom-mask">-->
<!--          <span class="share-text">共享车位</span>-->
<!--        </div>-->

<!--      </div>-->
        <div class="parking-image" >
          <img :src="getImgUrl(item.parkingImagesList)" alt="Parking" />
        </div>



        <div class="parking-details">
          <div class="parking-name">{{ item.parking?.name || '未知停车场' }}

            <img v-if="item.isSharedSpot" src="../assets/icons/share.png" style="width: 15px; height: 15px;">
            <img v-if="item.isReserve" src="../assets/icons/Calendar-Clock.png" style="width: 15px; height: 15px;margin-left:5px">
<!--            <el-tag style="margin-left:5px" >可预约</el-tag>-->

          </div>
          <div class="parking-address">
            {{ item.parking?.location || '' }} {{ truncateText(item.parking?.address, 12) || '地址未知' }}
          </div>

          <!-- Show promo tags if available -->
          <div class="promo-tags" v-if="item.promotions && item.promotions.length">
            <div class="promo-tag" v-for="(promo, promoIndex) in item.promotions" :key="promoIndex">
              {{ promo.name }}
            </div>
            <div class="action-tag">领</div>
          </div>

          <!-- Package details with modified display for shared spots -->
          <div class="package-item">
            <el-icon v-if="item.type === 'all_day'"><Timer /></el-icon>
            <el-icon v-else-if="item.type === 'night'"><Moon /></el-icon>
            <el-icon v-else-if="item.type === 'day'"><Sunny /></el-icon>
            <el-icon v-else-if="item.type === 'times'"><Clock /></el-icon>
            <el-icon v-else><Calendar /></el-icon>

            <!-- Different display format for shared spots (hourly) vs package spots (monthly/daily) -->
            <span v-if="item.isSharedSpot">
              {{ getPackageTypeLabel(item.type) }} (1{{ item.unitLabel || '时' }})
            </span>
            <span v-else>
              {{ getPackageTypeLabel(item.type) }} ({{ item.duration || 1 }}{{ item.unitLabel || '月' }})
            </span>

            <div class="package-price">¥{{ item.price || '?' }}</div>
          </div>
        </div>
        <div class="parking-metadata">
          <div class="package-count">{{ item.quantity || 0 }}个可售</div>
          <div class="distance" v-if="item.parking?.distance">{{ item.parking.distance }}</div>
        </div>
      </div>

      <!-- Load more button -->
<!--      <div class="load-more" v-if="hasMorePackages" @click="loadMorePackages">-->
<!--        加载更多-->
<!--      </div>-->
    </div>

  </div>

  <!-- Use the AppFooter component -->
  <AppFooter />
</template>

<script>
import { ref, onMounted, computed, watch, nextTick  } from 'vue'
import { useRouter } from 'vue-router'
import {
  ArrowLeft,
  ArrowDown,
  ArrowRight,
  MoreFilled,
  Search,
  Timer,
  Moon,
  Sunny,
  Calendar,
  Clock
} from '@element-plus/icons-vue'
import AppFooter from '@/components/AppFooter.vue'
import { listPackageSpotReleases } from '@/api/parking/packageSpotRelease'
import { getParkingSpaceInfo } from '@/api/parking/parkingSpace'
import { listSharedSpots } from '@/api/parking/sharedSpot'
import { pickParkingListThumbUrl } from '@/utils/parkingImage'

export default {
  components: {
    ArrowLeft,
    ArrowDown,
    ArrowRight,
    MoreFilled,
    Search,
    Timer,
    Moon,
    AppFooter,
    Sunny,
    Calendar,
    Clock
  },
  setup() {
    const router = useRouter()

    // Basic data
    const searchText = ref('')
    const isMapView = ref(true)
    const map = ref(null);
    const selectedParkingSpace = ref(null)
    const markers = ref([])
    const loading = ref(false)

    // Package spots data
    const packageSpots = ref([])
    const allSpots = ref([])
    const currentPage = ref(1)
    const shareCurrentPage = ref(1)
    const pageSize = ref(10)
    const total = ref(0)
    const hasMorePackages = computed(() => packageSpots.value.length < total.value)
    const inScorllSwitch=ref({packageSpot:true,sharedSpot:true})
    // User location (default to Nanjing center if not available)
    const userLocation = ref({
      latitude: 32.0584,
      longitude: 118.7965
    })

    // Selected city
    const selectedCity = ref('南京市')

    // Parking spaces cache
    const parkingSpacesCache = ref({})

    // Filter tabs
    const tabs = [
      { label: '充停一体', value: 'char_parking' },
      { label: '固定车位', value: 'fixed_parking' },
      { label: '充电车位', value: 'charging_parking' },
      { label: '月套餐', value: 'monthly' },
      { label: '日套餐', value: 'daily' },
      { label: '时套餐', value: 'times' },
      { label: '全天', value: 'all_day' },
      { label: '白天', value: 'day' },
      { label: '夜间', value: 'night' },
    ]
    const selectedTab = ref('monthly')

    // Get user's current position
    const getUserLocation = async () => {
      if (!navigator.geolocation) {
        console.warn("Geolocation not supported");
        return; // Exit early
      }

      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      // Wrap getCurrentPosition in a Promise
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, options);
        });

        userLocation.value = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };

        await fetchPackageSpots(true); // Wait for spots to load
        await fetchSharedSpotsData();
      } catch (error) {
        console.warn("Geolocation failed:", error.message);
        // Proceed with default data (already fetched in onMounted)
      }
    };

    const loadTiandituAPI = async () => {
      // Check if Tianditu API is already loaded
      if (window.T) {
        await initMap();
        return;
      }

      // Load Tianditu API script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      const tiandituKey = 'your-tianditu-key';
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tiandituKey}`;

      script.onload = async () => {
        await initMap();
      };

      script.onerror = () => {
        this.$message.error('加载地图API失败，请刷新页面重试');
      };

      document.head.appendChild(script);
    }

    const initMap = () => {
      // Create map instance - use window.T since we loaded it globally
      map.value = new window.T.Map('mapContainer');

      // Set initial center and zoom level
      const center = new window.T.LngLat(
          userLocation.value.longitude,
          userLocation.value.latitude
      );
      map.value.centerAndZoom(center, 13);

      // Add controls
      map.value.addControl(new window.T.Control.Zoom());
      // map.value.addControl(new window.T.Control.Scale());
      // map.value.addControl(new window.T.Control.MapType());

      // Enable interactions
      map.value.enableDrag();
      map.value.enableScrollWheelZoom();
      map.value.enableDoubleClickZoom();

      // Add current location marker
      addCurrentLocationMarker();
    };

    const addCurrentLocationMarker = () => {
      // Create current location marker
      const center = new window.T.LngLat(
          userLocation.value.longitude,
          userLocation.value.latitude
      );
      const currentMarker = new window.T.Marker(center);

      // Create custom icon for current location
      currentMarker.setIcon(new window.T.Icon({
        iconUrl: require('@/assets/images/location.png'),
        iconSize: new window.T.Point(24, 24),
        iconAnchor: new window.T.Point(12, 12)
      }));

      // Add marker to map
      map.value.addOverLay(currentMarker);
    };

    // Calculate distance between two coordinates
    const calculateDistance = (lat1, lon1, lat2, lon2) => {

      if (!lat1 || !lon1 || !lat2 || !lon2) {
        return null;
      }

      const R = 6371 // Radius of the earth in km
      const dLat = (lat2 - lat1) * Math.PI / 180
      const dLon = (lon2 - lon1) * Math.PI / 180
      const a =
        Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon/2) * Math.sin(dLon/2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
      const distance = R * c // Distance in km
      return distance
    }

    // Format distance for display
    const formatDistance = (distance) => {
      if (distance === undefined || distance === null) return '未知'
      if (distance < 1) return `${Math.round(distance * 1000)}米`
      return `${distance.toFixed(1)}公里`
    }

    // Fetch parking space details
    const fetchParkingSpaceDetails = async (parkingSpaceIds) => {
      console.log('fetchParkingSpaceDetails called with IDs:', parkingSpaceIds)
      
      // Skip if no IDs to fetch or all are already in cache
      if (!parkingSpaceIds.length ||
          parkingSpaceIds.every(id => parkingSpacesCache.value[id])) {
        console.log('Skipping fetch - no IDs or all in cache')
        return
      }

      try {
        // Only fetch the spaces we don't already have
        const idsToFetch = parkingSpaceIds.filter(id => !parkingSpacesCache.value[id])
        console.log('IDs to fetch:', idsToFetch)

        // Get parking spaces by their IDs using individual calls to bypass data scope
        const response = { rows: [] }
        
        for (const id of idsToFetch) {
          try {
            console.log(`Fetching parking space info for ID: ${id}`)
            const spaceResponse = await getParkingSpaceInfo(id)
            if (spaceResponse && spaceResponse.data) {
              // Convert the response format to match what the cache expects
              const space = {
                id: spaceResponse.data.parkingSpaceId,
                name: spaceResponse.data.parkingName,
                address: spaceResponse.data.address, // Use 'address' not 'fullAddress'
                fullAddress: spaceResponse.data.address,
                communityName: spaceResponse.data.parkingName, // Use parking name as community name
                photo: null,
                latitude: null,
                longitude: null,
                availableSpots: 0,
                spotCount: 0
              }
              response.rows.push(space)
            }
          } catch (error) {
            console.error(`Failed to fetch parking space ${id}:`, error)
          }
        }
        
        console.log('API response for parking spaces:', response)

        // Add to cache
        response.rows.forEach(space => {
          parkingSpacesCache.value[space.id] = {
            spaceId: space.id,
            name: space.name,
            address: space.fullAddress,
            location: space.communityName || '',
            latitude: space.latitude,
            longitude: space.longitude,
            imageUrl: space.photo || '',
            availableSpots: space.availableSpots,
            spotCount: space.spotCount,
            communityName: space.communityName
          }
        })
        
        // Debug: Log the cache to see what's being stored
        console.log('Parking spaces cache updated:', parkingSpacesCache.value)
      } catch (error) {
        console.error("Error fetching parking space details:", error)
      }
    }
    //搜索
    const parkingSearch=()=>{
      selectTab(selectedTab.value);
    }
    //分页
    const inScorll=()=>{

      if(inScorllSwitch.value.sharedSpot){
        fetchSharedSpotsData(false);
      }
      if(inScorllSwitch.value.packageSpot) {
        fetchPackageSpots(false);
      }
    }


    const fetchSharedSpotsData = async  (reset = true) => {
      console.log('fetchSharedSpotsData called with selectedTab:', selectedTab.value, 'reset:', reset)
      let Reserve=false;
      let reservationType="0";
      let timeType;
      if(selectedTab.value==="monthly"){
        reservationType="3";
      }
      if(selectedTab.value==="daily"){
        reservationType="2";
      }
      if(selectedTab.value==="times"){
        reservationType="1";
        Reserve=true;
      }
      // if (['all_day', 'day', 'night'].includes(selectedTab.value)) {
      //   reservationType="2";
      //   timeType = selectedTab.value;
      // }
      // durationType: "1",  // Continuous
      if (reset) {
        shareCurrentPage.value = 1;

      }
      try {
        const params = {
          pageNum: shareCurrentPage.value,
          pageSize: pageSize.value,
          shelvesStatus:1,
          notExpire:"1",
          reservationType: reservationType, // Time-based rental
          timeType:  timeType,
          parkingSpaceName: searchText.value
        };

        const response = await listSharedSpots(params);

        // Handle both response formats (TableDataInfo and AjaxResult)
        const spotsData = response.data || response.rows || [];

        // Extract unique parking space IDs
        const parkingSpaceIds = [...new Set(
            spotsData.map(item => item.parkingSpaceId)
        )];
        console.log('Shared spots data:', spotsData)
        console.log('Extracted parking space IDs for shared spots:', parkingSpaceIds)

        // Fetch parking space details
        await fetchParkingSpaceDetails(parkingSpaceIds);

        if(spotsData.length>0){
          shareCurrentPage.value++;
        }else {
          inScorllSwitch.value.sharedSpot=false;
        }
        // Map shared spots to the same format as package spots
        const enrichedSpots = spotsData.map(spot => {
          const parkingSpace = parkingSpacesCache.value[spot.parkingSpaceId] || {};
          // Debug: Log the parking space lookup for shared spots
          console.log(`Looking up parking space for shared spot ${spot.parkingSpaceId}:`, parkingSpace)

          const distance = calculateDistance(
              userLocation.value.latitude,
              userLocation.value.longitude,
              parkingSpace.latitude,
              parkingSpace.longitude
          );
          let unitData=getUnitLabel(spot);

          return {
            id: spot.id,
            sharedSpotId: spot.id, // Store the original shared spot ID
            type: selectedTab.value, // Mark as 'times' type
            isSharedSpot: true, // Flag to identify as shared spot
            duration: 1,
            price: unitData.price, // Use hourlyRate for shared spots
            unitLabel: unitData.unitLabel, // Explicitly mark as hourly rate
            quantity: spot.availableCount || 1,
            isReserve:Reserve,
            parking: {
              id: spot.parkingSpaceId,
              name: parkingSpace.name || '未知停车场',
              address: parkingSpace.address || '地址未知',
              location: parkingSpace.location || '',
              distance: formatDistance(distance),
              latitude: parkingSpace.latitude,
              longitude: parkingSpace.longitude,
              imageUrl: parkingSpace.imageUrl || ''
            },
            // Map tags to promotions if available
            promotions: spot.tags ? spot.tags.split(',').map(tag => ({ name: tag })) : [],
            // promotions: [{name:"共享车位"}]
          };
        });

        // Sort by distance
        enrichedSpots.sort((a, b) => {
          const distA = parseFloat(a.parking.distance);
          const distB = parseFloat(b.parking.distance);
          return distA - distB;
        });

        packageSpots.value = [...packageSpots.value,...enrichedSpots];
      } catch (error) {
        console.error('Error fetching shared spots:', error);
      }
    }

    const getUnitLabel=  (spot) =>{
      let unitLabel='';
      let price=0;
      if(selectedTab.value==="monthly"){
        unitLabel='月'
        price=spot.monthlyRate;
      }
      if(selectedTab.value==="daily"){
        unitLabel='日'
        price=spot.dailyRate;
      }
      if(selectedTab.value==="times"){
        unitLabel='时'
        price=spot.hourlyRate;
      }
      if(selectedTab.value==="all_day" || selectedTab.value==="day" || selectedTab.value==="night"){
        if(spot.durationUnit===1){
          unitLabel='月'
        }
        if(spot.durationUnit===2){
          unitLabel='日'
        }
        if(spot.durationUnit===3){
          unitLabel='昼'
        }
        if(spot.durationUnit===4){
          unitLabel='夜'
        }

      }
      if(selectedTab.value==="fixed_parking" || selectedTab.value==="char_parking"|| selectedTab.value==="charging_parking"){
        if(spot.durationUnit===1){
          unitLabel='月'
        }
        if(spot.durationUnit===2){
          unitLabel='日'
        }
        if(spot.durationUnit===3){
          unitLabel='昼'
        }
        if(spot.durationUnit===4){
          unitLabel='夜'
        }

      }
      return {unitLabel:unitLabel,price:price}

    }



    // Fetch package spots based on selected tab
    const fetchPackageSpots = async (reset = true) => {
      console.log('fetchPackageSpots called with selectedTab:', selectedTab.value, 'reset:', reset)

      try {
        if (reset) {
          currentPage.value = 1;
          packageSpots.value = [];
        }

        // Special handling for 'times' tab - use shared spots
        // if (selectedTab.value === 'times') {
        //   await fetchSharedSpots();
        //   return;
        // }

        const params = {
          pageNum: currentPage.value,
          pageSize: pageSize.value,
          parkingSpaceName: searchText.value
        };

        // Add filters based on selectedTab
        if (selectedTab.value === 'daily') {
          params.durationUnit = 2; // day
        } else if (selectedTab.value === 'monthly') {
          params.durationUnit = 1; // month
        } else if (['all_day', 'day', 'night'].includes(selectedTab.value)) {
          params.timeType = selectedTab.value;
          params.durationUnit = 2;
        }else if(selectedTab.value === 'fixed_parking'){
          params.isFixedSpot=1;
        }else if(selectedTab.value === 'char_parking'){
          params.advantageTagsQuery='充停一体';
        }
        else if(selectedTab.value === 'charging_parking'){
          params.advantageTagsQuery='有充电桩';
        }else if(selectedTab.value === 'times'){
          return;
        }
        loading.value = true;
     //   params.releaseAmount=1;

        // Add try-catch for the API call specifically
        try {
          console.log('Calling listPackageSpotReleases with params:', params)
          const response = await listPackageSpotReleases(params);
          console.log('Package spots API response:', response)

          // Handle both response formats (TableDataInfo and AjaxResult)
          const spotsData = response.data || response.rows || [];

            // Extract unique parking space IDs
          const parkingSpaceIds = [...new Set(
            spotsData.map(item => item.parkingSpaceId)
          )]
          console.log('Package spots data:', spotsData)
          console.log('Extracted parking space IDs:', parkingSpaceIds)
          
          if(spotsData.length>0){
            currentPage.value++

          }else {
            inScorllSwitch.value.packageSpot=false;
          }
          // Fetch parking space details
          await fetchParkingSpaceDetails(parkingSpaceIds)

          // Enrich package spots with parking details and calculate distances
          const enrichedSpots = spotsData.map(spot => {
            const parkingSpace = parkingSpacesCache.value[spot.parkingSpaceId] || {}
            // Debug: Log the parking space lookup
            console.log(`Looking up parking space ${spot.parkingSpaceId}:`, parkingSpace)
            // console.log(parkingSpace.latitude+"--------"+ parkingSpace.longitude)


            const distance = calculateDistance(
              userLocation.value.latitude,
              userLocation.value.longitude,
              parkingSpace.latitude,
              parkingSpace.longitude
            )
            let unitData=getUnitLabel(spot);
            return {
              ...spot,
              distance,
              distanceText: formatDistance(distance),
              parking: {
                id: spot.parkingSpaceId,
                name: parkingSpace.name || '未知停车场',
                address: parkingSpace.address || '地址未知',
                location: parkingSpace.location || '',
                distance: formatDistance(distance),
                latitude: parkingSpace.latitude,
                longitude: parkingSpace.longitude,
                imageUrl: parkingSpace.imageUrl || ''
              },
              // Map duration unit to type for icon display
              type: selectedTab.value,
              unitLabel:unitData.unitLabel,
              // Set duration based on unit
              duration: spot.durationUnit === 1 ? spot.durationValue || 1 : 1,
              // Use price from the spot
              price: spot.price,
              // Use availableInventory as quantity for real-time availability
              quantity: spot.availableInventory || spot.inventory || 0,
              isReserve:false,
              // Map advantage tags to promotions
              promotions: spot.advantageTags?.map(tag => ({ name: tag })) || []
            }
          })

          // Sort by distance
          enrichedSpots.sort((a, b) => a.distance - b.distance)

          if (reset) {
            packageSpots.value = enrichedSpots
          } else {
            packageSpots.value = [...packageSpots.value, ...enrichedSpots]
          }


          total.value = response.total || spotsData.length

        } catch (apiError) {
          console.warn("API call failed, using mock data:", apiError);
          // Use mock data but don't show error
          if (reset) {
            packageSpots.value = getMockPackageSpots();
          }
          total.value = packageSpots.value.length;
        }

        loading.value = false;
      } catch (error) {
        console.error('Error in fetchPackageSpots function:', error);
        loading.value = false;

        // Fallback to mock data
        if (reset) {
          packageSpots.value = getMockPackageSpots();
          total.value = packageSpots.value.length;
        }
      }
    }

    // Get mock data for fallback
    const getMockPackageSpots = () => {
      return [
        {
          id: 1,
          type: 'monthly',
          duration: 3,
          price: 799,
          quantity: 5,
          parking: {
            id: 101,
            name: '南京爱悦广场停车场',
            address: '南京市建邺区嘉陵江东街18号',
            location: '建邺区',
            distance: '1.2公里',
            imageUrl: ''
          },
          promotions: [
            { name: '满500减50' }
          ]
        },
        {
          id: 2,
          type: 'monthly',
          duration: 1,
          price: 350,
          quantity: 10,
          parking: {
            id: 102,
            name: '南京新百商场停车场',
            address: '南京市秦淮区中山南路1号',
            location: '秦淮区',
            distance: '2.5公里',
            imageUrl: ''
          },
          promotions: []
        },
        {
          id: 3,
          type: 'all_day',
          duration: 1,
          price: 250,
          quantity: 8,
          parking: {
            id: 103,
            name: '南京德基广场停车场',
            address: '南京市玄武区中山路18号',
            location: '玄武区',
            distance: '3.1公里',
            imageUrl: ''
          },
          promotions: [
            { name: '新人减20' }
          ]
        }
      ]
    }

    // Load more package spots
    const loadMorePackages = async () => {
      await fetchPackageSpots(false);
      await fetchSharedSpotsData(false);
      allSpots.value = packageSpots.value;
    }

    // Select a tab
    const selectTab = async (tab) => {
      selectedTab.value = tab

      await fetchPackageSpots()
      await fetchSharedSpotsData();
      allSpots.value = packageSpots.value;
      await setMapView(!isMapView.value);
    }

    // Go back to previous page
    const goBack = () => {
      router.push({ name: 'Home' })
    }

    // Navigate to city selector
    const goToCitySelector = () => {
      router.push({ name: 'CitySelector' })
    }

    // Select a package spot
    const selectPackage = (item) => {

      if (item.isSharedSpot) {
        // Handle shared spot selection differently
        router.push({
          path: '/payment/shared-spot',
          query: {
            sharedSpotId: item.sharedSpotId,
            name: item.parking?.name || '未知停车场',
            price: item.price,
            address: item.parking?.address || '',
            parkingLotId: item.parking?.id,
            selectedTab:selectedTab.value
          }
        });
      } else {

        // Original package spot selection
        router.push({
          path: '/payment/package-spot',
          query: {
            packageId: item.id,
            name: item.parking?.name || '未知停车场',
            price: item.price,
            quantity: item.quantity,
            address: item.parking?.address || '',
            parkingLotId: item.parking?.id,
            packageType: item.type,
            duration: item.duration,
            workdayTimes: item.workdayTimes || '',
            weekendTimes: item.weekendTimes || ''
          }
        });
      }
    }

    // Get package type label - update to include 'times' type
    const getPackageTypeLabel = (type) => {
      const typeMap = {
        'monthly': '月套餐',
        'daily': '日套餐',
        'times': '时套餐',
        'all_day': '全天套餐',
        'day': '白天套餐',
        'night': '夜间套餐',
        'fixed_parking': '固定车位',
        'char_parking': '充停一体',
        'charging_parking': '充电车位',
      }
      return typeMap[type] || '未知类型'
    }

    // Watch for search text changes
    watch(searchText, (newVal) => {
      if (newVal) {
        // Implement search functionality
        // This could filter the current list or fetch new data with a search parameter
      }
    })

    watch(selectedParkingSpace, (newVal) => {
      console.log("selectedParkingSpace changed", newVal)
      markers.value.forEach(marker => {
        const isSelected = marker.spaceId === newVal;
        const currentIcon = marker.getIcon();
        marker.setIcon(new window.T.Icon({
          iconUrl: currentIcon.options.iconUrl,
          iconSize: isSelected ? new window.T.Point(42, 42) : new window.T.Point(32, 32),
          iconAnchor: currentIcon.options.iconAnchor
        }));
      });
    });

    const updateParkingMarkers = () => {
      // Add markers for each parking space
      Object.values(parkingSpacesCache.value).forEach(space => { // Fixed: parkingSpaces.value → Object.values(parkingSpaces)
        if (space.latitude && space.longitude) {
          const position = new window.T.LngLat(space.longitude, space.latitude);
          const marker = new window.T.Marker(position);
          marker.spaceId = space.spaceId;

          // Set icon based on availability
          const isAvailable = space.availableSpots > 0;
          marker.setIcon(new window.T.Icon({
            iconUrl: require(`@/assets/images/parking-${isAvailable ? 'available' : 'full'}.png`),
            iconSize: new window.T.Point(32, 32),
            iconAnchor: new window.T.Point(24, 24)
          }));

          // Add click event
          marker.addEventListener('click', async () => {
            packageSpots.value = allSpots.value.filter(spot => spot.parkingSpaceId === space.spaceId);
            await nextTick();
            selectedParkingSpace.value = space.spaceId;
          });

          // Add hover events
          // marker.addEventListener('mouseover', () => {
          //   marker.openInfoWindow(infoWindow);
          // });
          //
          // marker.addEventListener('mouseout', () => {
          //   marker.closeInfoWindow();
          // });

          // Add to map and store reference
          map.value.addOverLay(marker);
          markers.value.push(marker);
        }
      });
    }

    const setMapView = async (value) => {
      selectedParkingSpace.value = null;
      isMapView.value = !value
      if(!isMapView.value)
      {
        await nextTick();
        await loadTiandituAPI();

        // Clear existing markers
        markers.value.forEach(marker => {
          map.value.removeOverLay(marker);
        });
        markers.value = [];

        if(allSpots.value.length > 0){
          const sortedSpots = [...allSpots.value].sort((a, b) => {
            if (a.distance === null) return 1;
            if (b.distance === null) return -1;
            return a.distance - b.distance;
          });
          const firstValid = sortedSpots.find(spot => spot.distance !== null);
          const nearestSpace = firstValid ?? sortedSpots[0];
          console.log("nearest parking spot:", nearestSpace.parkingSpaceId)

          packageSpots.value = sortedSpots.filter(spot => spot.parkingSpaceId === nearestSpace.parkingSpaceId);
          updateParkingMarkers();
          selectedParkingSpace.value = nearestSpace.parkingSpaceId;
        }
        else{
          selectedParkingSpace.value = null;
          packageSpots.value = []
        }
      }
      else{
        selectedParkingSpace.value = null;
        packageSpots.value = allSpots.value;
      }
    }

    // Load data on mount
    onMounted(async () => {
      await getUserLocation();
      allSpots.value = packageSpots.value;
      
      // Check for selected city from city selector
      const savedCity = sessionStorage.getItem('selectedCity');
      const savedCityCode = sessionStorage.getItem('selectedCityCode');
      if (savedCity) {
        selectedCity.value = savedCity;
        // Clear the saved city after using it
        sessionStorage.removeItem('selectedCity');
        sessionStorage.removeItem('selectedCityCode');
        
        // If we have a city code, we could use it to filter parking spaces
        if (savedCityCode) {
          console.log('Selected city with code:', savedCity, savedCityCode);
          // TODO: Implement city-based filtering of parking spaces
        }
      }
    })

    // Add this method to your component
    const truncateText = (text, maxLength = 15) => {
      if (!text) return '';
      return text.length > maxLength
        ? text.slice(0, maxLength) + '...'
        : text;
    }

    // Replace the getImgUrl function with this robust version
    const getImgUrl = (parkingImgList) => {
      const thumb = pickParkingListThumbUrl(parkingImgList)
      if (thumb) {
        return thumb
      }
      return require('@/assets/defaultParkImg.png')
    }

    return {
      searchText,
      isMapView,
      setMapView,
      selectedParkingSpace,
      packageSpots,
      loading,
      selectedTab,
      tabs,
      hasMorePackages,
      selectedCity,

      selectTab,
      goBack,
      goToCitySelector,
      loadMorePackages,
      selectPackage,
      getPackageTypeLabel,
      truncateText,
      getImgUrl,
      inScorll,
      parkingSearch

    }
  }
}
</script>

<style scoped>
.parking-page {
  background-color: #f5f5f5;
  /* min-height: 100vh; */
  /* padding-bottom: 60px; */
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #4080ff;
  color: white;
}

.back-button, .more-button {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.website {
  text-align: center;
  padding: 5px;
  background-color: #f0f9ff;
  color: #4080ff;
  font-size: 12px;
}

.search-row {
  display: flex;
  padding: 15px 5px;
  background-color: white;
  align-items: center;
}

.city-selector {
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.2s ease;
}

.city-selector:hover {
  color: #007AFF;
}

.search-container {
  flex: 1;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 20px;
  padding: 0 10px;
  height: 36px;
  margin: 0 10px;
}

.search-icon {
  color: #999;
  margin-right: 5px;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  height: 100%;
  font-size: 14px;
  width: 150px;
}

.search-input:focus {
  outline: none;
}

.search-button {
  background-color: #4080ff;
  color: white;
  padding: 4px 6px;
  border-radius: 15px;
  font-size: 12px;
}

.category-tabs {
  display: flex;
  overflow-x: auto;
  background-color: white;
  padding: 0 10px;
  margin-bottom: 10px;
  white-space: nowrap;
  scrollbar-width: none;
}

.category-tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  font-size: 14px;
  padding: 8px 12px;
  color: #666;
  position: relative;
}

.tab.active {
  color: #4080ff;
  font-weight: bold;
}

.tab.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 3px;
  background-color: #4080ff;
  border-radius: 3px;
}

.ad-banner {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #fff9f0;
  margin-bottom: 10px;
}

.map-container {
  height: 250px;
  width: 100%;
  position: relative;
  z-index: 1; /* Ensure it's not covered by other elements */
  pointer-events: auto; /* Explicitly enable pointer events */
}

.follow-tag {
  font-size: 11px;
  background-color: #ff6034;
  color: white;
  padding: 1px 4px;
  border-radius: 4px;
  margin-right: 8px;
}

.ad-content {
  flex: 1;
  font-size: 14px;
  color: #333;
}

.parking-list {
  background-color: white;
}

.parking-item {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #e0dcdc;
  background-color: white;
}

.image-container {
  margin-right: 10px;
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 8px; /* 可选圆角 */
  overflow: hidden; /* 隐藏超出部分 */
}

.content-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.bottom-mask {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25px; /* 蒙版高度 */
  background: rgba(64, 128, 255, 0.7); /* 蓝色蒙版 */ display: flex; align-items: center;  padding: 0 16px;
}

.share-text {
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5); /* 文字阴影 */
}





.parking-image {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
}

.parking-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.parking-details {
  flex: 1;
}

.parking-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}

.parking-address {
  font-size: 13px;
  color: #666;
  margin-bottom: 5px;
}

.package-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-top: 5px;
}

.package-item .el-icon {
  margin-right: 5px;
  color: #4080ff;
}

.package-price {
  margin-left: auto;
  color: #ff6034;
  font-weight: bold;
}

.parking-metadata {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  min-width: 70px;
  text-align: right;
}

.package-count {
  font-size: 13px;
  color: #333;
}

.distance {
  font-size: 12px;
  color: #999;
}

.promo-tags {
  display: flex;
  margin-top: 5px;
}

.promo-tag {
  font-size: 11px;
  color: #ff6034;
  border: 1px solid #ff6034;
  padding: 1px 4px;
  border-radius: 4px;
  margin-right: 5px;
}

.action-tag {
  font-size: 11px;
  color: white;
  background-color: #ff6034;
  padding: 1px 4px;
  border-radius: 4px;
}

.empty-state {
  padding: 30px;
  text-align: center;
  color: #999;
}

.loading-state {
  padding: 20px;
  text-align: center;
  color: #999;
}

.load-more {
  text-align: center;
  padding: 15px;
  color: #4080ff;
  background-color: #fff;
  border-top: 1px solid #eee;
  margin-bottom: 60px;
}

.hidden {
  display: none;
}
.view-toggle {
  display: flex;
  gap: 10px;
  text-align: center;
}
.view-toggle img {
  cursor: pointer;
}
.icon-label{
  font-size: 12px;
  margin-top: -3px;
}
</style>
